// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2Uawo","detailsBorder":"styles_detailsBorder__3dkIq"};